export const PackageIcon: React.FC<React.ComponentProps<"svg">> = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5021 1.40267C8.15292 2.74507 5.84574 4.06346 3.50386 5.40167C2.57555 5.9376 2.0011 6.92626 2 7.9989V16.001C2.00108 17.0531 2.58879 18.0699 3.5 18.596L10.5 22.596C11.4484 23.1432 12.5495 23.1438 13.4982 22.597L20.4961 18.5982C21.4079 18.0747 21.9989 17.0518 22 16.001V7.9989C21.9989 6.91321 21.4375 5.9452 20.5 5.40389L13.4979 1.4027C12.5868 0.877661 11.4132 0.877648 10.5021 1.40267ZM13 20.5782L19.5 16.8639C19.8031 16.6887 19.9996 16.3491 20 15.9989V8.53739L13 12.5866V20.5782ZM11 12.587L4 8.53774V15.9993C4.00051 16.3493 4.19569 16.6875 4.49842 16.863L11 20.5782V12.587ZM12.5 3.13596L18.961 6.82793L16.5051 8.24853L9.5609 4.24403L11.4961 3.13818C11.8013 2.96199 12.1942 2.95941 12.5 3.13596ZM11.9997 10.8548L14.5065 9.40469L7.54998 5.39312L5.03874 6.8281L11.9997 10.8548Z"
        fill="currentColor"
      />
    </svg>
  );
};
